export default {
    "stay-connected": "Stay connected",
    questions: "Have questions or need extra support?",
    contact: "Contact us",
    register: "Sign up",
    poweredby: "Powered by",
    terms: "Terms",
    privacy: "Privacy",
};
